import i18n from "~/assets/js/Helpers/i18n";

export const groupBy = (key) => (array) =>
    array.reduce((objectsByKeyValue, obj) => {
        const value = obj[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
    }, {});

export const groupByDay = (deliveryTimes) => {
    const newArray = [];

    deliveryTimes.map((deliveryTime) => {
        deliveryTime.deliveryDay = deliveryTime.begin.split("T")[0];
        deliveryTime.deliveryHourStart = deliveryTime.begin
            .split("T")[1]
            .substring(0, 5);
        deliveryTime.deliveryHourEnd = deliveryTime.end
            .split("T")[1]
            .substring(0, 5);

        deliveryTime.timeSlot = `${deliveryTime.deliveryHourStart} - ${deliveryTime.deliveryHourEnd} Uhr`;
        newArray.push(deliveryTime);
    });
    return newArray;
};

export const isoToHumanReadable = (isoDate) => {
    const m = isoDate.getMonth() + 1;
    const d = isoDate.getDate();
    const y = isoDate.getFullYear();

    return `${d}.${m}.${y}`;
};

export const formatDate = (date) => {
    const week = [
        i18n.t("days.sunday"),
        i18n.t("days.monday"),
        i18n.t("days.tuesday"),
        i18n.t("days.wednesday"),
        i18n.t("days.thursday"),
        i18n.t("days.friday"),
        i18n.t("days.saturday"),
    ];
    const today = new Date();
    const currentDate = new Date(date);
    let append = "";

    if (currentDate.getDate() === today.getDate()) {
        append = i18n.t("days.today");
    } else if (currentDate.getDate() === today.getDate() + 1) {
        append = i18n.t("days.tomorrow");
    } else {
        append = week[currentDate.getDay()];
    }

    return {
        append: append,
        date: isoToHumanReadable(currentDate),
    };
};
